import React, { useContext } from 'react';

import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Signin.scss';

import { EXTERNAL_API } from '../../../shared/config/globalConfig';
import { TranslationContext } from '../../../App';

/**
 *
 * @returns
 */
const Signin = () => {
  const { t } = useContext(TranslationContext);

  return (
    <a
      href={`${EXTERNAL_API}auth/linkedin-login?redirectUri=${encodeURIComponent(
        window.location.href
      )}`}
      className="login-btn btn"
    >
      <FontAwesomeIcon icon={faLinkedin} /> {t('Header.signIn')}
    </a>
  );
};
export default Signin;
